import React from 'react'
import { Dispatch } from 'redux'
import { connect } from 'react-redux'
import { SortableContainer } from 'react-sortable-hoc'
import { calculatePriority } from '../../services/sort'
import { IGroupDetailed } from '../../types/group'
import { updateGroup } from '../../actions/group'
import { updateGroupsDetailed } from '../../actions/groupsDetailed'
import { selectGroupsByOrder } from '../../selectors/groupsDetailed'
import { ReorderTableBody, ReorderTableHead } from './ReorderTable'
import { StyledOrderTable } from './ReorderTable/styled'

export interface IReorderGroupsTab {
  list: IGroupDetailed[]
  dispatch: Dispatch
}

const ReorderGroupsTabComponent = ({ list, dispatch }) => {
  const SortableList = SortableContainer(ReorderTableBody)
  const onSortEnd = ({ oldIndex, newIndex }): void => {
    if (oldIndex !== newIndex) {
      const newOrder = calculatePriority(list, oldIndex, newIndex, 'order')
      dispatch(
        updateGroupsDetailed(
          list.map((item, index) =>
            index === oldIndex ? { ...item, order: newOrder } : item
          )
        )
      )
      dispatch(updateGroup({ ...list[oldIndex], order: newOrder }))
    }
  }

  return (
    <StyledOrderTable>
      <ReorderTableHead />
      <SortableList
        list={list}
        onSortEnd={onSortEnd}
        helperClass="media-type-list-sorted-item"
        useDragHandle
      />
    </StyledOrderTable>
  )
}

export const ReorderGroupsTab = connect(selectGroupsByOrder)(
  ReorderGroupsTabComponent
)
